import React from 'react';
import { Alert } from 'reactstrap';
import { Icon } from '../Component';

/**
 * Error Boundary Component for WhatsApp Chat
 * Catches JavaScript errors anywhere in the child component tree
 */
class WhatsAppChatErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log the error to console for debugging
        console.error('WhatsApp Chat Error:', error, errorInfo);

        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="p-4">
                    <Alert color="danger" className="d-flex align-items-center">
                        <Icon name="alert-circle" className="me-2 flex-shrink-0" />
                        <div>
                            <h6 className="mb-1">Something went wrong</h6>
                            <p className="mb-0">
                                The WhatsApp chat component encountered an error. Please try refreshing or contact support if the problem persists.
                            </p>
                            {process.env.NODE_ENV === 'development' && this.state.error && (
                                <details className="mt-2">
                                    <summary>Error Details (Development Only)</summary>
                                    <pre className="mt-2 small text-muted">
                                        {this.state.error.toString()}
                                        {this.state.errorInfo.componentStack}
                                    </pre>
                                </details>
                            )}
                        </div>
                    </Alert>
                </div>
            );
        }

        return this.props.children;
    }
}

export default WhatsAppChatErrorBoundary;